export default {"src":"/_next/static/media/HR.09474132.svg","height":355,"width":512,"blurWidth":0,"blurHeight":0};